/**
 * Labstep
 *
 * @module prosemirror/extensions/cursor
 * @desc Cursor management
 */

import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from 'prosemirror-gapcursor';
import type { LabstepExtension } from '../types';

export const ExtensionCursor: LabstepExtension = {
  plugins: [dropCursor(), gapCursor()],
};
